import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  submitEnd(event) {
    if (!event.detail.success) return

    this.element.closest("dialog")?.close()
    Turbo.visit(event.detail.fetchResponse.response.url, { action: "replace" })
  }
}
